export class UnknownErrorException {}